import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { destroy } from 'redux-form';

import { AUDIO_GENERATE } from 'forms/list';
import DisplayConceptBreadCrumb from 'widgets/modals/DisplayConceptBreadcrumb';
import AudioAdSettings from './AudioAdSettings';
import AudioPreview from './AudioPreview';

import './style.css';

const breadcrumbSteps = ['Audio Ad Settings', 'Preview Audio'];

export default function CreateGeneratedAudioModal(props) {
	const { libraryId, closeModal } = props;
	const dispatch = useDispatch();
	const [previewVersions, setPreviewVersions] = useState([]);

	useEffect(() => {
		return () => {
			dispatch(destroy(AUDIO_GENERATE));
		};
	}, []);

	const commonModalProps = {
		title: 'New Generated Audio',
		type: "modal",
		allowFullScreen: false,
		className: "generate-audio white-title-bar add-content-modal",
		xClose: true,
		closeModal,
		libraryId: parseInt(libraryId),
	};

	if (!previewVersions.length) {
		return (
			<AudioAdSettings
				commonModalProps={commonModalProps}
				Breadcrumb={<DisplayConceptBreadCrumb stepNames={breadcrumbSteps} currentStep={0} />}
				formName={AUDIO_GENERATE}
				setPreviewVersions={setPreviewVersions}
			/>
		);
	}

	return (
		<AudioPreview
			commonModalProps={commonModalProps}
			Breadcrumb={<DisplayConceptBreadCrumb stepNames={breadcrumbSteps} currentStep={1} />}
			formName={AUDIO_GENERATE}
			versions={previewVersions}
			goBack={() => setPreviewVersions([])}
		/>
	);
}
